import React, { Component, useEffect, useState } from 'react';
import { getOrderCache, order_key } from '../../utils/order_cache';
import SelectPaymentMethodView from './SelectPaymentMethodView';

function SelectPaymentMethodController(props) {
    const [payment_method_type, setPaymentMethodType] = useState(props.paymentMethod ? props.paymentMethod : "CASH");
    const [payment_method_types, setPaymentMethodTypes] = useState(props.order_type == 'PICK_UP' || props.order_type == 'DIRECT_SALE' ? getOrderCache(order_key.pick_up_store).payment_method_types : getOrderCache(order_key.delivery_fulfilled_by).payment_method_types);

    useEffect(() => {
        if (payment_method_types && payment_method_types.length == 1) {
            setPaymentMethodType(payment_method_types[0])
        }
    }, [])
    return (
        <div>
            <SelectPaymentMethodView
                open={props.open}
                onClose={props.onClose}
                showLoading={props.showLoading}
                primary_card={props.primary_card}
                primary_paypal={props.primary_paypal}
                onNext={() => props.onNext(payment_method_type)}
                payment_method={payment_method_type}
                onSelectPaymentMethod={setPaymentMethodType}
                onAddCard={props.onAddCard}
                onChangeCard={props.onChangeCard}
                payment_method_types={payment_method_types} />
        </div>
    );
}

export default SelectPaymentMethodController;